import { Phone, Download, ExternalLink, Mail, MessageCircle } from 'lucide-react';

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-navy-light py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* CTA Section */}
        <div className="text-center mb-12">
          <h2 className="font-serif text-2xl md:text-3xl font-bold text-white mb-4">
            Potřebujete osobní konzultaci?
          </h2>
          <p className="text-gray-400 mb-8 max-w-xl mx-auto">
            Rezervujte si bezplatný 15minutový hovor a probereme vaši finanční situaci. 
            Pomůžu vám nastavit správnou strategii pro vaše cíle.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://pancungradi.simplybook.it/v2/#book"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-booking-btn"
              className="btn-gold flex items-center justify-center gap-2"
            >
              <Phone className="w-5 h-5" />
              Zarezervovat hovor ZDARMA
            </a>
            <a
              href="#typeform-section"
              data-testid="footer-plan-btn"
              className="btn-outline flex items-center justify-center gap-2"
            >
              <Download className="w-5 h-5" />
              Získat finanční plán
            </a>
          </div>
        </div>

        {/* Contact & Links */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 pt-8 border-t border-navy-lighter">
          {/* Contact */}
          <div className="text-center md:text-left">
            <h4 className="text-white font-semibold mb-4">Kontakt</h4>
            <a
              href="mailto:ahoj@nguyenductrung.cz"
              className="flex items-center justify-center md:justify-start gap-2 text-gray-400 hover:text-gold transition-colors mb-3"
            >
              <Mail className="w-4 h-4" />
              ahoj@nguyenductrung.cz
            </a>
          </div>

          {/* Links */}
          <div className="text-center">
            <h4 className="text-white font-semibold mb-4">Odkazy</h4>
            <div className="space-y-2">
              <a
                href="https://www.pancung.cz/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-1 text-gray-400 hover:text-gold transition-colors text-sm"
              >
                www.pancung.cz
                <ExternalLink className="w-3 h-3" />
              </a>
              <a
                href="https://kviz.pancung.cz/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-1 text-gray-400 hover:text-gold transition-colors text-sm"
              >
                Finanční kvíz
                <ExternalLink className="w-3 h-3" />
              </a>
            </div>
          </div>

          {/* Community */}
          <div className="text-center md:text-right">
            <h4 className="text-white font-semibold mb-4">Komunita</h4>
            <a
              href="https://discord.gg/bCdRj6hYtR"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="discord-link"
              className="inline-flex items-center gap-2 bg-[#5865F2] hover:bg-[#4752C4] text-white px-4 py-2 rounded-lg transition-colors text-sm font-medium"
            >
              <MessageCircle className="w-4 h-4" />
              Discord komunita
            </a>
          </div>
        </div>

        {/* Copyright */}
        <p className="text-center text-gray-500 text-sm mt-8 pt-8 border-t border-navy-lighter">
          © {new Date().getFullYear()} Pan Čung Radí. Všechna práva vyhrazena.
        </p>
      </div>
    </footer>
  );
};
